import { axiosInstance } from "@/axios.instance";
import { apiFormattingMixins } from "@/mixins";
import { AxiosInstance } from "axios";
import { PaginatedSearchRequest } from "@/mixins/PaginatedSearch";
import AreaContactsPagedResponse from "@/types/sv-data/contacts/AreaContactsPaginatedResponse";
const { arrayToQueryString } = apiFormattingMixins.methods;

class UserApi {
	private axios: AxiosInstance;

	constructor() {
		this.axios = axiosInstance;
	}

	public async checkUserHasPermissionToGroup(groupId: string, permissions: string[] = []): Promise<boolean> {
		const permissionsAsQueryString = arrayToQueryString("permissions", permissions);
		const { data } = await this.axios.get(`users/HasPermissions?groupId=${groupId}&${permissionsAsQueryString}`);
		return data;
	}

	public async getKeyContactsByGroup(groupId: number, paginatedSearchRequest?: PaginatedSearchRequest) : Promise<AreaContactsPagedResponse> {
		return (await this.axios.get(`/users/KeyContacts/Group/${groupId}`, paginatedSearchRequest)).data;
	}

	public async getContactRolesByGroup(groupId: number): Promise<string[]> {
		return (await this.axios.get(`/users/ContactRoles/Group/${groupId}`)).data;
	}
}

const userApi = new UserApi();
export default userApi;
